import { DsMapCategoryInterface } from '../interfaces/ds-map-category.interface';

export class DsMapCategory {
  /**
   *
   */
  public id: number;

  /**
   *
   */
  public name: string;

  /**
   * Number of maps linked to the map category.
   */
  public nbMaps?: number;

  /**
   * Creates an instance of DsPlanCategory.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsMapCategoryInterface) {
    this.id = jsonData.id;
    this.name = jsonData.nom || jsonData.name;
    this.nbMaps = jsonData.nbPlans;
  }
}
